import '@babel/polyfill'; //- needed for mocking .finally() with Promisses
import { shallowMount, createLocalVue } from '@vue/test-utils';
import Vuex from 'vuex';
import PaymentUpdateSubsModal from './PaymentUpdateSubsModal';

const localVue = createLocalVue();
localVue.use(Vuex);

describe('PaymentUpdateSubsModal', () => {
  let wrapper;
  let store;
  let updateLastSavedProfileMock;
  let getCustomerPaymentProfilesMock;
  let updatePaymentProfileForSubscriptions;
  let loadCustomerSubsMock;
  let setSavingProfileMock;
  let hideModalMock;

  const lastSavedProfile = { paymentProfileId: 456 };
  const subs = [{ id: 123, products: [{ product_name: 'Name 1' }], has_extra_tube: true }, { id: 234, products: [{ product_name: 'Name 2' }] }];

  beforeEach(() => {
    updateLastSavedProfileMock = jest.fn();
    getCustomerPaymentProfilesMock = jest.fn();
    updatePaymentProfileForSubscriptions = jest.fn(() => Promise.resolve('Result'));

    loadCustomerSubsMock = jest.fn();
    setSavingProfileMock = jest.fn();
    hideModalMock = jest.fn();

    store = new Vuex.Store({
      modules: {
        payments: {
          namespaced: true,
          state: {
            editProfileForm: {},
            lastSavedProfile: lastSavedProfile
          },

          actions: {
            updateLastSavedProfile: updateLastSavedProfileMock,
            updatePaymentProfileForSubscriptions: updatePaymentProfileForSubscriptions,
            getCustomerPaymentProfiles: getCustomerPaymentProfilesMock
          },

          mutations: {
            setSavingProfile: setSavingProfileMock
          }
        },

        subscriptions: {
          namespaced: true,
          state: {
            subsToUpdate: subs
          },
          getters: {
            activeSubscriptions: jest.fn()
          },

          actions: {
            loadCustomerSubs: loadCustomerSubsMock
          }
        },

        modal: {
          namespaced: true,
          actions: {
            hideModal: hideModalMock
          }
        }
      }
    });

    wrapper = shallowMount(PaymentUpdateSubsModal, {
      store,
      localVue
    });
  });

  test('general snapshot', () => {
    expect(wrapper.html()).toMatchSnapshot();
  });

  describe('methods', () => {
    describe('onSubmit', () => {
      test('set subIds in payload to array of sub ids', () => {
        wrapper.vm.onSubmit();
        expect(updatePaymentProfileForSubscriptions).toHaveBeenCalledTimes(1);
        expect(updatePaymentProfileForSubscriptions.mock.calls[0][1]).toEqual({ subIds: subs.map(sub => sub.id), paymentProfileId: lastSavedProfile.paymentProfileId });
      });

      test('expected calls', () => {
        return wrapper.vm.onSubmit().then(() => {
          //- setSavingProfile
          expect(setSavingProfileMock).toHaveBeenCalledTimes(2);
          expect(setSavingProfileMock.mock.calls[0][1]).toEqual(true);
          expect(setSavingProfileMock.mock.calls[1][1]).toEqual(false);
          //- updateLastSavedProfile
          expect(updateLastSavedProfileMock).toHaveBeenCalledTimes(1);
          expect(updateLastSavedProfileMock.mock.calls[0][1]).toEqual({});
          //- loadCustomerSubs
          expect(loadCustomerSubsMock).toHaveBeenCalledTimes(1);
          //- refresh payment profiles
          expect(getCustomerPaymentProfilesMock).toHaveBeenCalledTimes(1);
          //- hide modal emit
          expect(hideModalMock).toHaveBeenCalledTimes(1);
        });
      });
    });

    describe('cancel', () => {
      test('emit event to close modal', () => {
        wrapper.vm.cancel();
        expect(hideModalMock).toHaveBeenCalledTimes(1);
      });

      test('call updateLastSavedProfile with empty Object', () => {
        wrapper.vm.cancel();
        expect(updateLastSavedProfileMock).toHaveBeenCalledTimes(1);
        expect(updateLastSavedProfileMock.mock.calls[0][1]).toEqual(expect.any(Object));
      });
    });
  });

});